import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Shield, Users, AlertTriangle, Scale } from 'lucide-react';

const TermsPage = () => {
  const lastUpdated = '15 de janeiro de 2026';

  const sections = [
    {
      id: 'acceptance',
      icon: FileText,
      title: '1. Aceitação dos Termos',
      content: `
        Ao acessar e usar a plataforma hello, social, você concorda em cumprir e estar vinculado a estes Termos de Uso. 
        Se você não concordar com qualquer parte destes termos, não poderá acessar o serviço.

        Estes termos se aplicam a todos os visitantes, usuários e outras pessoas que acessam ou usam o serviço.
        Ao criar uma conta, você confirma que tem pelo menos 18 anos de idade ou que possui consentimento dos pais/responsáveis.
      `
    },
    {
      id: 'services',
      icon: Shield,
      title: '2. Descrição dos Serviços',
      content: `
        A hello, social é uma plataforma de criação de conteúdo para redes sociais que utiliza inteligência artificial para:

        • Gerar imagens e conteúdos visuais baseados em prompts de texto
        • Criar vídeos curtos através de IA generativa
        • Conectar-se às suas contas de redes sociais (Instagram, TikTok) para publicação
        • Armazenar e gerenciar sua identidade visual e marca
        • Agendar publicações automáticas

        Os serviços estão sujeitos a limites de uso conforme o plano contratado.
      `
    },
    {
      id: 'accounts',
      icon: Users,
      title: '3. Contas de Usuário',
      content: `
        Para usar nossos serviços, você deve criar uma conta fornecendo informações precisas e completas.
        Você é responsável por:

        • Manter a confidencialidade da sua senha
        • Todas as atividades que ocorrem em sua conta
        • Notificar-nos imediatamente sobre qualquer uso não autorizado

        Reservamo-nos o direito de suspender ou encerrar contas que violem estes termos.
      `
    },
    {
      id: 'content',
      icon: FileText,
      title: '4. Conteúdo Gerado e Propriedade Intelectual',
      content: `
        4.1 Conteúdo que Você Fornece:
        Você mantém todos os direitos sobre o conteúdo que você fornece à plataforma, incluindo textos, imagens e informações da marca.

        4.2 Conteúdo Gerado por IA:
        O conteúdo gerado pela nossa IA a partir dos seus prompts é licenciado para seu uso comercial e pessoal.
        Você pode usar, modificar e distribuir esse conteúdo livremente.

        4.3 Restrições:
        Você não pode usar a plataforma para gerar:
        • Conteúdo ilegal, difamatório ou que viole direitos de terceiros
        • Material pornográfico ou sexualmente explícito
        • Conteúdo que promova violência, discriminação ou ódio
        • Deepfakes ou conteúdo enganoso sobre pessoas reais
        • Spam ou conteúdo malicioso
      `
    },
    {
      id: 'social',
      icon: Shield,
      title: '5. Conexões com Redes Sociais',
      content: `
        5.1 Autorização OAuth:
        Ao conectar suas contas de Instagram, TikTok ou outras redes sociais, você nos autoriza via OAuth 2.0 (protocolo seguro de autorização) a:
        • Publicar conteúdo em seu nome
        • Acessar informações básicas do seu perfil
        • Agendar publicações

        5.2 Segurança:
        • Nunca armazenamos suas senhas de redes sociais
        • Utilizamos tokens de acesso criptografados
        • Você pode revogar o acesso a qualquer momento

        5.3 Responsabilidade:
        O conteúdo publicado em suas redes sociais é de sua responsabilidade. 
        Certifique-se de que está em conformidade com as políticas de cada plataforma.
      `
    },
    {
      id: 'payments',
      icon: Scale,
      title: '6. Pagamentos e Assinaturas',
      content: `
        6.1 Planos e Preços:
        Oferecemos diferentes planos de assinatura com preços e recursos específicos.
        Os preços podem ser alterados com aviso prévio de 30 dias.

        6.2 Cobrança:
        • As assinaturas são cobradas automaticamente no início de cada período
        • Aceitamos cartões de crédito, PIX e boleto via Stripe
        • Todos os pagamentos são processados de forma segura

        6.3 Cancelamento:
        • Você pode cancelar a qualquer momento
        • O acesso continua até o fim do período pago
        • Não há reembolso proporcional para cancelamentos antecipados

        6.4 Reembolsos:
        Oferecemos reembolso integral em até 7 dias após a primeira cobrança se você não estiver satisfeito.
      `
    },
    {
      id: 'limits',
      icon: AlertTriangle,
      title: '7. Limites de Uso',
      content: `
        Cada plano possui limites específicos de:
        • Quantidade de imagens geradas por mês
        • Quantidade de vídeos por IA
        • Número de contas sociais conectadas
        • Qualidade das gerações (padrão, HD, 4K)

        O uso excessivo ou abusivo pode resultar em:
        • Throttling (redução temporária de velocidade)
        • Suspensão temporária do serviço
        • Encerramento da conta em casos graves
      `
    },
    {
      id: 'disclaimer',
      icon: AlertTriangle,
      title: '8. Isenção de Garantias',
      content: `
        O serviço é fornecido "como está" e "conforme disponível", sem garantias de qualquer tipo.
        Não garantimos que:
        • O serviço será ininterrupto ou livre de erros
        • Os resultados da IA atenderão suas expectativas específicas
        • O conteúdo gerado será adequado para todos os fins

        Em caso de indisponibilidade, faremos esforços razoáveis para restaurar o serviço.
      `
    },
    {
      id: 'liability',
      icon: Scale,
      title: '9. Limitação de Responsabilidade',
      content: `
        Em nenhuma circunstância a hello, social será responsável por:
        • Danos indiretos, incidentais ou consequenciais
        • Perda de lucros, dados ou oportunidades de negócio
        • Ações de terceiros ou problemas nas plataformas de redes sociais
        • Conteúdo gerado que viole políticas de terceiros

        Nossa responsabilidade total está limitada ao valor pago nos últimos 12 meses.
      `
    },
    {
      id: 'changes',
      icon: FileText,
      title: '10. Alterações nos Termos',
      content: `
        Podemos modificar estes termos a qualquer momento. Alterações significativas serão comunicadas por:
        • E-mail para usuários registrados
        • Notificação na plataforma
        • Aviso no site com pelo menos 30 dias de antecedência

        O uso continuado após as alterações constitui aceitação dos novos termos.
      `
    },
    {
      id: 'contact',
      icon: Users,
      title: '11. Contato',
      content: `
        Para dúvidas sobre estes Termos de Uso, entre em contato:

        E-mail: contato@hellosocial.com.br
        
        Endereço: São Paulo, SP - Brasil

        Responderemos em até 5 dias úteis.
      `
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link 
              to="/" 
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="font-medium">Voltar</span>
            </Link>
            
            <Link to="/" className="flex items-center gap-2">
                          <img src="/logo.png" alt="hello, social" className="w-12 h-12 object-contain" />
                        </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="py-16 px-4 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-amber-100 to-orange-100 rounded-2xl flex items-center justify-center">
            <FileText className="w-8 h-8 text-amber-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Termos de Uso
          </h1>
          <p className="text-gray-600">
            Última atualização: {lastUpdated}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Intro */}
          <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 mb-8">
            <p className="text-amber-800">
              <strong>Importante:</strong> Leia estes termos com atenção antes de usar a plataforma. 
              Ao usar nossos serviços, você concorda com todos os termos descritos abaixo.
            </p>
          </div>

          {/* Table of Contents */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-8">
            <h2 className="font-bold text-gray-900 mb-4">Índice</h2>
            <div className="grid sm:grid-cols-2 gap-2">
              {sections.map((section) => (
                <a
                  key={section.id}
                  href={`#${section.id}`}
                  className="text-sm text-gray-600 hover:text-amber-600 transition-colors"
                >
                  {section.title}
                </a>
              ))}
            </div>
          </div>

          {/* Sections */}
          <div className="space-y-8">
            {sections.map((section) => {
              const Icon = section.icon;
              return (
                <div
                  key={section.id}
                  id={section.id}
                  className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 scroll-mt-24"
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-gray-600" />
                    </div>
                    <h2 className="text-xl font-bold text-gray-900">{section.title}</h2>
                  </div>
                  <div className="prose prose-gray max-w-none">
                    {section.content.split('\n').map((paragraph, idx) => (
                      <p key={idx} className="text-gray-600 mb-3 whitespace-pre-line">
                        {paragraph.trim()}
                      </p>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Footer Note */}
          <div className="mt-12 text-center">
            <p className="text-gray-500 text-sm">
              Ao usar a plataforma hello, social, você concorda com estes termos.
            </p>
            <div className="flex items-center justify-center gap-4 mt-4">
              <Link to="/privacy" className="text-amber-600 hover:text-amber-700 font-medium text-sm">
                Política de Privacidade →
              </Link>
              <Link to="/plans" className="text-amber-600 hover:text-amber-700 font-medium text-sm">
                Ver Planos →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 bg-white border-t border-gray-100">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="hello, social" className="w-8 h-8 object-contain" />
            <span className="font-semibold text-gray-900">hello, social</span>
          </div>
          
          <p className="text-sm text-gray-500">
            © 2026 hello, social. Todos os direitos reservados.
          </p>

          <div className="flex items-center gap-6">
            <Link to="/terms" className="text-sm text-amber-600 font-medium">
              Termos
            </Link>
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-gray-700 transition-colors">
              Privacidade
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;